let canvas: HTMLCanvasElement | null = null;
let context: CanvasRenderingContext2D | null = null;

export const measureTextWidth = ({
	text,
	fontSize,
	fontFamily,
}: {
	text: string;
	fontSize: number | string;
	fontFamily: string;
}) => {
	if (!canvas) {
		canvas = document.createElement('canvas');
		context = canvas.getContext('2d');
	}

	if (context) {
		context.font = `${typeof fontSize === 'string' ? fontSize : `${fontSize}px`} ${fontFamily}`;

		return context.measureText(text).width;
	}

	return 0;
};
